// extracted by mini-css-extract-plugin
module.exports = {"structure-container-item-wrapper":"i_GC","structure-container-item":"i_GD","structure-items":"i_GE"};